module.exports = __webpack_public_path__ + "img/cp6-1.c894eb58.jpg";